import { Navigate, useLocation, Outlet } from 'react-router-dom'
import Sidebar from '@/shared/components/layout/Sidebar'
import { SidebarProvider, useSidebar } from '@/contexts/SidebarContext'

const ProtectedRouteContent: React.FC = () => {
  const location = useLocation()
  const token = localStorage.getItem('authToken')
  const { mainSidebarCollapsed, setMainSidebarCollapsed } = useSidebar()

  if (!token) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 布局样式
  const layoutStyle = {
    display: 'flex',
    minHeight: '100vh', // 改为 minHeight 而不是 height
    background: '#f8fafc',
  }

  const mainContentStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    marginLeft: mainSidebarCollapsed ? '0px' : '260px', // 根据侧边栏状态调整间距
    transition: 'margin-left 0.3s ease',
    overflowX: 'hidden' as const, // 限制横向溢出，让子元素的横向滚动生效
    // 移除 overflow: hidden，让内容可以撑开高度
  }

  const contentWrapperStyle = {
    flex: 1,
    // 不设置 overflow: auto，让页面自然滚动
    // 移除高度限制
  }

  return (
    <div style={layoutStyle}>
      <Sidebar collapsed={mainSidebarCollapsed} onCollapsedChange={setMainSidebarCollapsed} />
      <div style={mainContentStyle}>
        <div style={contentWrapperStyle}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

const ProtectedRoute: React.FC = () => {
  return (
    <SidebarProvider>
      <ProtectedRouteContent />
    </SidebarProvider>
  )
}

export default ProtectedRoute